module.exports = __webpack_public_path__ + "img/flag.63746099.svg";